// extracted by mini-css-extract-plugin
export default {"overlay":"global-loader_overlay__RuZ-J","box":"global-loader_box__tFbcm"};